import { routes } from './allowance'

export { routes }
